import classNames from 'classnames';
import { Icon, Button, FlexContainer, Txt } from 'components';
import { useTenancy } from 'state';
import styles from './Signed.module.scss';

/**
 * Signed
 *
 * @return {JSX.Element}
 */
const Signed = ({ className }) => {
  const tenancyDoc = useTenancy();
  const tenancyData = tenancyDoc.data;

  return (
    <FlexContainer
      className={classNames(styles.Signed, className, Signed.displayName)}
      column
      gap
    >
      <Txt bold>Agreement is signed 🎉</Txt>
      <Txt regular>Congratulations you have a tenancy agreement signed.</Txt>
      <Txt regular>
        Now you have a legally binding contract to reference in the event a
        party does not commit to the obligations set out in your agreement.
      </Txt>
      <Txt regular>
        You can view this document in the tenancy or using the button below.
      </Txt>
      <a
        className={styles.ButtonLink}
        href={tenancyData.agreement.pdfDocumentUrl}
        target="_blank"
        rel="noreferrer"
      >
        <Button flex reverse>
          <FlexContainer flex spaceBetween>
            <Txt>View the signed agreement</Txt>
            <Icon name="goto" />
          </FlexContainer>
        </Button>
      </a>
    </FlexContainer>
  );
};

Signed.displayName = 'Signed';

export default Signed;
